import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwittwerIcon from "@mui/icons-material/Twitter";
import MailIcon from "@mui/icons-material/Mail";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import TelegramIcon from "@mui/icons-material/Telegram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { FaLinkedin, FaTiktok } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { Avatar, Button, Drawer, Grid, Link, Tooltip } from "@mui/material";
import { centered_flex_box, left_flex_box, right_flex_box } from "./Styles";
import StarsIcon from "@mui/icons-material/Stars";
import YouTube from "@mui/icons-material/YouTube";
import { marketingColors, marketingFonts } from "./tickitMarketingTheme";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { usesPlatformChrome } from "./platform/pageChrome";

const footerLinkSx = {
  color: "rgba(255, 255, 255, 0.92) !important",
  textDecoration: "none",
  fontFamily: marketingFonts.body,
  fontWeight: 600,
  fontSize: "0.95rem",
  "&:hover": {
    color: "#ffffff !important",
    textDecoration: "underline",
    textUnderlineOffset: "3px",
  },
};

function Footer({ role }) {
  const { pathname } = useLocation();
  if (usesPlatformChrome(pathname, role)) {
    return null;
  }

  return (
    <Box component="footer" sx={{ 
      width: "100%", 
      maxWidth: "100%", 
      boxSizing: "border-box",
      position: "relative",
      overflow: "hidden",
      zIndex: 1,
      flexShrink: 0,
      marginTop: "auto"
    }}>
      <Box
        className="footer"
        sx={{
          flexGrow: 1,
          background: `linear-gradient(135deg, ${marketingColors.p900} 0%, ${marketingColors.p700} 42%, ${marketingColors.p600} 100%)`,
          backdropFilter: "blur(20px)",
          boxShadow: "0 -8px 32px rgba(30, 5, 80, 0.35)",
          borderTop: "1px solid rgba(255, 255, 255, 0.12)",
          color: "#ffffff",
          width: "100%",
          maxWidth: "100%",
          padding: 5,
          paddingBottom: 0,
          boxSizing: "border-box",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Grid container spacing={{ xs: 3, md: 30 }} mb={2}>
          <Grid item xs={12} md={4}>
            <Typography
              fontSize={20}
              fontWeight={800}
              sx={{ fontFamily: marketingFonts.display, color: "#fff", mb: 1.5 }}
            >
              About Us
            </Typography>
            <Typography
              textAlign="justify"
              sx={{
                fontFamily: marketingFonts.body,
                fontWeight: 400,
                color: "rgba(255, 255, 255, 0.82)",
                lineHeight: 1.65,
                fontSize: "0.95rem",
              }}
            >
              Tickit is an innovative online ticketing solution whose aim is to
              revolutionize the way events are managed by leveraging our fast,
              efficient, and easy-to-use barcode technology.
            </Typography>
          </Grid>
          {/* <Grid item xs={isMobile ? 12 : 3}>
                        <Typography fontSize={20} fontWeight="bold">Follow Us</Typography>
                        <Grid container>
                            <Grid item xs={4} sx={centered_flex_box}>
                                <IconButton>
                                    <FacebookIcon fontSize='large' sx={{ color: "var(--mainWhite)" }} />
                                </IconButton>
                            </Grid>
                            <Grid item xs={4} sx={centered_flex_box}>
                                <IconButton>
                                    <InstagramIcon fontSize='large' sx={{ color: "var(--mainWhite)" }} />
                                </IconButton>
                            </Grid>
                            <Grid item xs={4} sx={centered_flex_box}>
                                <IconButton>
                                    <TwittwerIcon fontSize='large' sx={{ color: "var(--mainWhite)" }} />
                                </IconButton>
                            </Grid>
                            <Grid item xs={4} sx={centered_flex_box}>
                                <IconButton>
                                    <YouTube fontSize='large' sx={{ color: "var(--mainWhite)" }} />
                                </IconButton>
                            </Grid>
                            <Grid item xs={4} sx={centered_flex_box}>
                                <IconButton>
                                    <FaTiktok size="30" color="var(--mainWhite)" />
                                </IconButton>
                            </Grid>
                            <Grid item xs={4} sx={centered_flex_box}>
                                <IconButton>
                                    <FaLinkedin size="30" color="var(--mainWhite)" />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid> */}
          <Grid item xs={12} md={4}>
            <Typography
              fontSize={20}
              fontWeight={800}
              sx={{ fontFamily: marketingFonts.display, color: "#fff", mb: 1.5 }}
            >
              Links
            </Typography>
            <Typography sx={{ display: "block", lineHeight: 1.8 }}>
              <Link component={NavLink} to="/contact" sx={footerLinkSx} display="inline-block">
                {" > Contact Us"}
              </Link>
            </Typography>
            <Typography sx={{ display: "block", lineHeight: 1.8 }}>
              <Link component={NavLink} to="/faqs" sx={footerLinkSx} display="inline-block">
                {" > FAQs"}
              </Link>
            </Typography>
            <Typography sx={{ display: "block", lineHeight: 1.8 }}>
              <Link component={NavLink} to="/careers" sx={footerLinkSx} display="inline-block">
                {" > Join Us"}
              </Link>
            </Typography>
            <Typography sx={{ display: "block", lineHeight: 1.8 }}>
              <Link component={NavLink} to="/events/request" sx={footerLinkSx} display="inline-block">
                {" > TICKIt-ify Your Event"}
              </Link>
            </Typography>
            <Typography sx={{ display: "block", lineHeight: 1.8 }}>
              <Link component={NavLink} to="/refund-policy" sx={footerLinkSx} display="inline-block">
                {" > Refund Policy"}
              </Link>
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography
              fontSize={20}
              fontWeight={800}
              sx={{ fontFamily: marketingFonts.display, color: "#fff", mb: 1.5 }}
            >
              Follow Us
            </Typography>
            {/* <Typography textAlign="justify" fontWeight={10}>
              <FacebookIcon /> TickIt Egypt
            </Typography> */}
            <Typography
              textAlign="justify"
              sx={{ color: "rgba(255,255,255,0.9)", fontFamily: marketingFonts.body, display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }}
            >
              <InstagramIcon sx={{ color: "rgba(255,255,255,0.95)", fontSize: 22 }} />{" "}
              <Link
                href="https://www.instagram.com/tickit.events/"
                target="_blank"
                rel="noopener noreferrer"
                sx={footerLinkSx}
              >
                @tickit.events
              </Link>
            </Typography>
            <Typography
              textAlign="justify"
              sx={{ color: "rgba(255,255,255,0.9)", fontFamily: marketingFonts.body, display: "flex", alignItems: "center", gap: 0.75, mt: 1, flexWrap: "wrap" }}
            >
              <WhatsAppIcon sx={{ color: "rgba(255,255,255,0.95)", fontSize: 22 }} />{" "}
              <Link
                href="https://wa.me/message/QCHGXGG2ZHTCJ1"
                target="_blank"
                rel="noopener noreferrer"
                sx={footerLinkSx}
              >
                Tickit
              </Link>
            </Typography>
            {/* <Typography textAlign="justify">
              <FaTiktok /> @TickItEgypt
            </Typography> */}
          </Grid>
        </Grid>

        <hr
          style={{
            border: 0,
            borderTop: "solid 2px rgba(255, 255, 255, 0.2)",
            opacity: "100%",
            margin: 0,
          }}
        />
      </Box>
      <Box
        className="footer"
        sx={{
          backgroundColor: marketingColors.p900,
          borderTop: "1px solid rgba(255, 255, 255, 0.08)",
          color: "#ffffff",
          width: "100%",
          maxWidth: "100%",
          padding: 4,
          boxSizing: "border-box",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4} sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
            <Typography
              fontWeight={700}
              sx={{ fontFamily: marketingFonts.body, fontSize: "0.85rem", color: "rgba(255,255,255,0.88)" }}
            >
              © 2025 Q R Tick For Events
            </Typography>
            <Typography
              fontWeight={700}
              sx={{ fontFamily: marketingFonts.body, fontSize: "0.85rem", color: "rgba(255,255,255,0.88)" }}
            >
              © 2025 كيو ار تك للفعاليات
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
            sx={{ ...centered_flex_box, flexDirection: "column" }}
          >
            <Typography fontWeight={700} textAlign="center">
              <Link component={NavLink} to="/terms" sx={footerLinkSx}>
                {"Terms & Conditions"}
              </Link>
            </Typography>
            <Typography fontWeight={700} textAlign="center">
              <Link component={NavLink} to="/policy" sx={footerLinkSx}>
                {"Privacy Policy"}
              </Link>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} sx={{ ...right_flex_box, justifyContent: { xs: 'center', sm: 'flex-end' } }}>
            <Typography fontWeight={700} textAlign="right">
              <Link
                href="https://tech.integraegy.com"
                target="_blank"
                rel="noopener noreferrer"
                sx={footerLinkSx}
              >
                Developed By Integra
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

const mapStateToProps = (state) => ({
  role: state?.auth?.token?.split(" ")[0],
});

export default connect(mapStateToProps)(Footer);
